import { Controller } from "@hotwired/stimulus"

// dialog-dismiss — fecha o dialog ancestral assim que este elemento é conectado
// ao DOM. Usado quando um Turbo Stream de SUCESSO (ex.: criar cartão pelo modal)
// precisa fechar o modal a partir do servidor: o stream injeta um nó com este
// controller dentro do dialog, ele acha o `[data-controller~="dialog"]` acima e
// chama closeNow() (fecho síncrono, sem depender de clique).
//
// Reaproveitável em qualquer fluxo "criar registro relacionado sem sair da página".
export default class extends Controller {
  connect() {
    const dialogEl = this.element.closest('[data-controller~="dialog"]')
    if (!dialogEl) return
    const ctrl = this.application.getControllerForElementAndIdentifier(dialogEl, "dialog")
    if (ctrl) ctrl.closeNow()
  }
}
